module.exports = __webpack_public_path__ + "img/wb0t3.70b74602.png";